export default __webpack_public_path__ + "static/media/facebook_1502290925364.0a127898.jpg";